import { createFileRoute } from '@tanstack/react-router'

import { LeadSubmissionsPage } from '#/modules/content/lead-submissions-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/lead-submissions')({
  component: LeadSubmissionsPage,
  validateSearch: validateListSearch,
})
